import React from 'react';

import {
  getColorNameByType,
  getTitleByType,
} from 'App/components/News/constants';

import {
  Typography,
  Stack,
  ArticleOutlinedIcon,
  makeStyles,
  ListItemAvatar,
  Avatar,
} from '@gogame/components';
import { DateValueFormatter } from '@gogame/intl-ts';

const useStyles = makeStyles((theme) => {
  return {
    avatar: {
      border: `1px solid ${theme.palette.grey[100]}`,
      background: theme.palette.common.white,
    },
  };
});

const NewsTitle = ({ type, date }) => {
  const classes = useStyles();

  return (
    <Stack direction={'row'} alignItems={'center'}>
      <ListItemAvatar>
        <Avatar className={classes.avatar}>
          <ArticleOutlinedIcon color={getColorNameByType(type)} />
        </Avatar>
      </ListItemAvatar>
      <Stack>
        <Typography>{getTitleByType(type)}</Typography>
        <Typography variant={'overline'}>
          <DateValueFormatter
            value={date}
            template={'LLL'}
            timeZone={'local'}
          />
        </Typography>
      </Stack>
    </Stack>
  );
};

export default NewsTitle;
